import React from 'react';
import CalculationSheet from '../components/CalculationSheet';
import './PublicCalculation.css';
export default function PublicCalculation(){
 return <main className="public-calculation">
  <header className="public-calculation-brand"><strong>Studio C.I.S.A.</strong><span>Calcolatore del risarcimento</span></header>
  <CalculationSheet publicMode/>
  <p className="public-calculation-note">Versione di prova. Il risultato è indicativo e non sostituisce la valutazione del caso. I valori inseriti non vengono salvati né inviati al gestionale.</p>
 </main>;
}
